import { render } from 'react-dom'
import React from 'react'
import App from 'app'
import reducers from 'careers/reducers'
import routes from 'careers/routes'
import { initializeStore } from '../store'
import Router from '../components/router/router'

export default function () {
  if (!document.querySelector('#localstorage-error')) {
    return initializeStore(reducers)
      .then(({ store, history }) => render(
        <App store={store}>
          <Router history={history} routes={routes} />
        </App>,
        document.querySelector('#container')
      ))
  }
  return Promise.resolve()
}
